import { useState } from "react";

// Stylized dot-matrix US coverage map (decorative, approximate silhouette).
const DOTS = [
  // west coast
  [60, 70], [58, 90], [66, 110], [72, 128], [80, 146],
  [84, 66], [90, 84], [96, 104], [102, 122],
  // mountain
  [118, 72], [124, 92], [130, 112], [136, 132], [142, 150],
  [150, 70], [156, 90], [162, 110], [168, 130],
  // central
  [184, 66], [190, 86], [196, 106], [202, 126], [208, 146],
  [216, 70], [222, 90], [228, 110], [234, 130],
  // midwest / great lakes
  [250, 62], [256, 82], [262, 102], [268, 122], [274, 142],
  [282, 66], [288, 86], [294, 106],
  // northeast
  [308, 70], [314, 90], [320, 108], [330, 78], [338, 96],
  // southeast
  [300, 128], [308, 146], [284, 150], [292, 132], [276, 158],
];

const HUBS = [
  { x: 72, y: 128, label: "SACRAMENTO" },
  { x: 96, y: 82, label: "BOISE" },
  { x: 136, y: 132, label: "AUSTIN · HQ" },
  { x: 268, y: 122, label: "COLUMBUS" },
  { x: 300, y: 128, label: "TAMPA" },
  { x: 330, y: 78, label: "ALBANY" },
];

export const USMap = ({ className = "" }) => {
  const [hover, setHover] = useState(null);
  return (
    <div className={`relative ${className}`} data-testid="coverage-map">
      <svg viewBox="0 0 400 220" className="h-auto w-full">
        {DOTS.map(([x, y], i) => (
          <circle key={i} cx={x} cy={y} r="2.4" fill="#9CA3AF" opacity="0.55" />
        ))}
        {HUBS.map((h) => (
          <g key={h.label} onMouseEnter={() => setHover(h)} onMouseLeave={() => setHover(null)} className="cursor-pointer" data-testid={`coverage-hub-${h.label.split(" ")[0].toLowerCase()}`}>
            <circle cx={h.x} cy={h.y} r={hover === h ? 14 : 9} fill="#2F4BE0" opacity="0.14" style={{ transition: "r 200ms" }} />
            <circle cx={h.x} cy={h.y} r="4" fill="#2F4BE0" />
            <circle cx={h.x} cy={h.y} r="4" fill="#2F4BE0" className="animate-pulse-dot" />
          </g>
        ))}
        {hover && (
          <g pointerEvents="none">
            <rect x={Math.min(hover.x - 4, 300)} y={hover.y - 30} width="96" height="18" rx="4" fill="#0B1220" />
            <text x={Math.min(hover.x - 4, 300) + 6} y={hover.y - 18} fill="#fff" fontSize="8" fontFamily="monospace" letterSpacing="0.5">{`${hover.label} · LIVE`}</text>
          </g>
        )}
      </svg>
      <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1">
        {HUBS.map((h) => (
          <span key={h.label} className="font-mono-label text-[9px] text-oath-muted">
            ● {h.label}
          </span>
        ))}
      </div>
      <div className="mt-2 font-mono-label text-[9px] text-oath-accent">
        FIG. 04 — FIELD NETWORK · LIVE COVERAGE, 41 STATES
      </div>
    </div>
  );
};

export default USMap;
